import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for withdrawal requests.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format the date according to the application's configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Define the form for unlocking a user by password
        const desbloquear_usuario_clave = {
            view: 'form', // Specify the view type as a form
            margin: 10, // Set margin around the form
            // Determine visibility based on permission configuration
            hidden: !devConfig.getPermAction('betShopManagementSecurityChangesUserClaveSwitch', 'Switch'),
            css: 'secutity prm-betShopManagementSecurityChangesUserClaveSwitch', // Apply CSS classes for styling
            id: 'desbloquearclaveestadoUsuario', // Unique identifier for the form
            rows: [
                // Define the rows within the form
                { view: 'label', label: _('Desbloquear Usuario por Clave') }, // Label for the form
                {
                    css: 'centrar', // CSS class for centering the button
                    id: 'UnlockUserByPassword', // Unique identifier for the button
                    view: 'button', // Specify the view type as a button
                    labelWidth: 55, // Set width for the label
                    value: _('Desbloquear'), // Button label for unlocking
                    click: () => {
                        // Define the click event handler for the button
                        webix
                            .ajax() // Initiate an AJAX request
                            .headers({
                                'Content-type': 'application/json', // Set content type to JSON
                            })
                            .post(
                                devConfig.geturlApi() + // API endpoint for user security update
                                'Client/UpdateUserSecurity',
                                '{"Action":"UnlockUserByPassword","Id":' + // Request payload for unlocking user
                                cur_user +
                                ',"IsActivate":"A"}',
                                {
                                    error: function(text, data, XmlHttpRequest) {
                                        // Handle error response from the server
                                        webix.message({
                                            title: _('¡Error!'), // Error message title
                                            type: 'alert-error', // Error message type
                                            text: _('Ocurrio un error.'), // Error message text
                                        });
                                    },
                                    success: function(text, data, XmlHttpRequest) {
                                        text = JSON.parse(text); // Parse the response text to JSON
                                        if (text.HasError) {
                                            // Check if the response indicates an error
                                            webix.message({
                                                title: _('¡Error!'), // Error message title
                                                type: 'alert-error', // Error message type
                                                text: _('Ocurrio un error.'), // Error message text
                                            });
                                        } else {
                                            // Notify the user of successful changes
                                            webix.message(_('Cambios Realizados'));
                                        }
                                    },
                                },
                            );
                    },
                },
            ],
        };

        const left = {
            margin: 0, // Margin for the left container
            rows: [
                {
                    margin: 0, // Margin for the row
                    id: 'a1', // Unique identifier for the row
                    css: 'on-row', // CSS class for styling
                    cols: [
                        desbloquear_usuario_clave, // Reference to an external component or variable
                        {
                            view: 'form', // Form view for generating password
                            margin: 10, // Margin for the form
                            css: 'secutity prm-betShopManagementSecurityGeneratePasswordSwitch', // CSS classes for styling
                            id: 'generatePassword', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission to display the form
                                'betShopManagementSecurityGeneratePasswordSwitch',
                                'Switch',
                            ),
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Generar contraseña'), // Text for the label
                                },
                                {
                                    css: 'centrar', // CSS class for centering
                                    id: 'GeneratePassword', // Unique identifier for the button
                                    view: 'button', // Button view
                                    labelWidth: 55, // Width of the label
                                    value: _('Generar'), // Text for the button
                                    click: () => { // Click event handler for the button
                                        webix
                                            .ajax() // AJAX request to the server
                                            .headers({
                                                'Content-type': 'application/json', // Set content type to JSON
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                '{"Action":"GeneratePassword","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                {
                                                    error: function(text, data, XmlHttpRequest) { // Error callback
                                                        webix.message({
                                                            title: _('¡Error!'), // Error message title
                                                            type: 'alert-error', // Error message type
                                                            text: _('Ocurrio un error.'), // Error message text
                                                        });
                                                    },
                                                    success: function(text, data, XmlHttpRequest) { // Success callback
                                                        text = JSON.parse(text); // Parse response text
                                                        if (text.HasError) { // Check for errors in response
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        } else {
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for generating second password
                            margin: 10, // Margin for the form
                            css: 'secutity prm-betShopManagementSecurityGeneratePassword2Switch', // CSS classes for styling
                            id: 'generatePassword', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission to display the form
                                'betShopManagementSecurityGeneratePassword2Switch',
                                'Switch',
                            ),
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Generar contraseña'), // Text for the label
                                },
                                {
                                    css: 'centrar', // CSS class for centering
                                    id: 'GeneratePassword2', // Unique identifier for the button
                                    view: 'button', // Button view
                                    labelWidth: 55, // Width of the label
                                    value: _('Generar'), // Text for the button
                                    click: () => { // Click event handler for the button
                                        webix
                                            .ajax() // AJAX request to the server
                                            .headers({
                                                'Content-type': 'application/json', // Set content type to JSON
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                '{"Action":"GeneratePassword2","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                {
                                                    error: function(text, data, XmlHttpRequest) { // Error callback
                                                        webix.message({
                                                            title: _('¡Error!'), // Error message title
                                                            type: 'alert-error', // Error message type
                                                            text: _('Ocurrio un error.'), // Error message text
                                                        });
                                                    },
                                                    success: function(text, data, XmlHttpRequest) { // Success callback
                                                        text = JSON.parse(text); // Parse response text
                                                        if (text.HasError) { // Check for errors in response
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        } else {
                                                            webix.message({
                                                                title: _('Contraseña cambiada'), // Success message title
                                                                type: 'alert-warning', // Success message type
                                                                text: text.Data, // Success message text
                                                            });
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for user state management
                            css: 'secutity prm-betShopManagementSecurityChangesUserEstadoSwitch', // CSS classes for styling
                            id: 'estadoUsuario', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission to display the form
                                'betShopManagementSecurityChangesUserEstadoSwitch',
                                'Switch',
                            ),
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Usuario'), // Text for the label
                                },
                                {
                                    css: 'centrar', // CSS class for centering
                                    id: 'StateSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Text for the switch on state
                                    offLabel: _('Inactivo'), // Text for the switch off state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"State","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"State","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for contingency recharge management
                            id: 'ContingencyRecarga', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission to display the form
                                'betShopManagementSecurityChangesContingencyRecargaSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesContingencyRecargaSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Recarga'), // Text for the label
                                },
                                {
                                    css: 'centrar', // CSS class for centering
                                    id: 'StateContingencyRecargaSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Text for the switch on state
                                    offLabel: _('Inactivo'), // Text for the switch off state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyRecargaSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"AllowRecarga","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyRecargaSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"AllowRecarga","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyRecargaSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for contingency state management
                            id: 'Contingency', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission to display the form
                                'betShopManagementSecurityChangesContingencyEstadoSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesContingencyEstadoSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Contingencia'), // Text for the label
                                },
                                {
                                    id: 'StateContingencySwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Text for the switch on state
                                    offLabel: _('Inactivo'), // Text for the switch off state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencySwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencySwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencySwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for previous DNI verification
                            id: 'DniAnterior', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesVerificoDniAntSwitch', 'Switch'), // Check permission to display the form
                            css: 'secutity prm-customersSecurityChangesVerificoDniAntSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Verificó DNI anterior'), // Text for the label
                                },
                                {
                                    id: 'StateDniAnterior', // Unique identifier for the switch
                                    view: 'switch', // Switch view
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Sí'), // Text for the switch on state
                                    offLabel: _('No'), // Text for the switch off state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateDniAnterior').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"DniAnterior","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateDniAnterior').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"DniAnterior","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateDniAnterior').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for posterior DNI verification
                            id: 'DniPosterior', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('customersSecurityChangesVerificoDniPostSwitch', 'Switch'), // Check permission to display the form
                            css: 'secutity prm-customersSecurityChangesVerificoDniPostSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Verificó DNI posterior'), // Text for the label
                                },
                                {
                                    id: 'StateDniPosterior', // Unique identifier for the switch
                                    view: 'switch', // Switch view
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Si'), // Text for the switch on state
                                    offLabel: _('No'), // Text for the switch off state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateDniPosterior').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"DniPosterior","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateDniPosterior').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"DniPosterior","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateDniPosterior').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 0, // Margin for the row
                    css: 'on-row', // CSS class for styling
                    id: 'a2', // Unique identifier for the row
                    cols: [
                        {
                            view: 'form', // Form view for sports contingency management
                            id: 'ContingencyDeportivas', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission to display the form
                                'betShopManagementSecurityChangesContingencyDeportivasSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesContingencyDeportivasSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Contingencia Deportivas'), // Text for the label
                                },
                                {
                                    id: 'StateContingencyDeportivasSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Text for the switch on state
                                    offLabel: _('Inactivo'), // Text for the switch off state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyDeportivasSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencySports","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyDeportivasSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencySports","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyDeportivasSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for casino contingency management
                            id: 'ContingencyCasino', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission to display the form
                                'betShopManagementSecurityChangesContingencyCasinoSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesContingencyCasinoSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Contingencia Casino'), // Text for the label
                                },
                                {
                                    id: 'StateContingencyCasinoSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Text for the switch on state
                                    offLabel: _('Inactivo'), // Text for the switch off state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyCasinoSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyCasino","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyCasinoSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyCasino","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyCasinoSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for live casino contingency management
                            id: 'ContingencyCasinoVivo', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission to display the form
                                'betShopManagementSecurityChangesContingencyCasinoVivoSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesContingencyCasinoVivoSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Contingencia Casino en Vivo'), // Text for the label
                                },
                                {
                                    id: 'StateContingencyCasinoVivoSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Text for the switch on state
                                    offLabel: _('Inactivo'), // Text for the switch off state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyCasinoVivoSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyCasinoVivo","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyCasinoVivoSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyCasinoVivo","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyCasinoVivoSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for virtual contingency management
                            id: 'ContingencyVirtuales', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission to display the form
                                'betShopManagementSecurityChangesContingencyVirtualesSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesContingencyVirtualesSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Contingencia Virtuales'), // Text for the label
                                },
                                {
                                    id: 'StateContingencyVirtualesSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Text for the switch on state
                                    offLabel: _('Inactivo'), // Text for the switch off state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyVirtualesSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyVirtuales","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyVirtualesSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyVirtuales","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyVirtualesSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for poker contingency management
                            id: 'ContingencyPoker', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission to display the form
                                'betShopManagementSecurityChangesContingencyPokerSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesContingencyPokerSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Contingencia Poker'), // Text for the label
                                },
                                {
                                    id: 'StateContingencyPokerSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Text for the switch on state
                                    offLabel: _('Inactivo'), // Text for the switch off state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyPokerSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyPoker","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyPokerSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyPoker","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyPokerSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for withdrawal contingency management
                            id: 'ContingencyWithdrawals', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission to display the form
                                'betShopManagementSecurityChangesContingencyWithdrawalsSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesContingencyWithdrawalsSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Contingencia Retiros'), // Text for the label
                                },
                                {
                                    id: 'StateContingencyWithdrawalsSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Text for the switch on state
                                    offLabel: _('Inactivo'), // Text for the switch off state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyWithdrawalsSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyWithdrawals","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyWithdrawalsSwith').setValue(1); // Set switch value to on
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint
                                                    '{"Action":"ContingencyWithdrawals","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyWithdrawalsSwith').setValue(0); // Set switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 0, // Setting margin to zero
                    css: 'on-row', // Applying CSS class for styling
                    id: 'a3', // Unique identifier for this component
                    autoheight: true, // Automatically adjust height based on content
                    cols: [ // Array of column definitions
                        {
                            view: 'form', // Form view for updating IP
                            id: 'UpdateIP', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission for displaying this form
                                'betShopManagementSecurityChangesUpdateIPSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesUpdateIPSwitch', // CSS classes for styling
                            rows: [ // Array of rows within the form
                                { view: 'label', label: _('Actualizar IP') }, // Label for the form
                                {
                                    view: 'text', // Text input for IP address
                                    name: 'IP', // Name of the input field
                                    id: 'IP', // Unique identifier for the input field
                                    label: _('IP'), // Label for the input field
                                    labelPosition: 'top', // Position of the label
                                    placeholder: _('IP'), // Placeholder text for the input field
                                    labelWidth: 200, // Width of the label
                                },
                                {
                                    css: 'centrar', // CSS class for centering the button
                                    id: 'UpdateIpButton', // Unique identifier for the button
                                    view: 'button', // Button view
                                    labelWidth: 55, // Width of the label
                                    value: _('Actualizar'), // Button text
                                    click: () => { // Click event handler for the button
                                        webix
                                            .ajax() // Initiating an AJAX request
                                            .headers({
                                                'Content-type': 'application/json', // Setting content type to JSON
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                '{"Action":"UpdateIP","Id":' +
                                                cur_user + // Current user ID
                                                ',"IP":"' +
                                                $$('IP').getValue() + // Getting the value of the IP input
                                                '"}',
                                                {
                                                    error: function(text, data, XmlHttpRequest) { // Error callback
                                                        webix.message('Error! '); // Displaying error message
                                                    },
                                                    success: function(text, data, XmlHttpRequest) { // Success callback
                                                        webix.message(_('Cambios Realizados')); // Displaying success message
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for IP restriction
                            id: 'ContingencyRestriccionIP', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission for displaying this form
                                'betShopManagementSecurityChangesContingencyRestriccionIPSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesContingencyRestriccionIPSwitch', // CSS classes for styling
                            rows: [ // Array of rows within the form
                                { view: 'label', label: _('Restricción IP') }, // Label for the form
                                {
                                    id: 'StateContingencyRestriccionIPSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for activation
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyRestriccionIPSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyRestriccionIP","Id":' +
                                                    cur_user + // Current user ID
                                                    ',"IsActivate":"A"}', // Activation status
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({ // Displaying error message
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Displaying success message
                                                            $$('StateContingencyRestriccionIPSwith').setValue(1); // Setting switch value to on
                                                        },
                                                    },
                                                );
                                        } else { // If switch is off
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyRestriccionIP","Id":' +
                                                    cur_user + // Current user ID
                                                    ',"IsActivate":"I"}', // Deactivation status
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({ // Displaying error message
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Displaying success message
                                                            $$('StateContingencyRestriccionIPSwith').setValue(0); // Setting switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for token IP
                            id: 'ContingencyTokenIP', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission for displaying this form
                                'betShopManagementSecurityChangesContingencyTokenIPSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesContingencyTokenIPSwitch', // CSS classes for styling
                            rows: [ // Array of rows within the form
                                { view: 'label', label: 'Token IP' }, // Label for the form
                                {
                                    id: 'StateContingencyTokenIPSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for activation
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyTokenIPSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyTokenIP","Id":' +
                                                    cur_user + // Current user ID
                                                    ',"IsActivate":"A"}', // Activation status
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({ // Displaying error message
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Displaying success message
                                                            $$('StateContingencyTokenIPSwith').setValue(1); // Setting switch value to on
                                                        },
                                                    },
                                                );
                                        } else { // If switch is off
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyTokenIP","Id":' +
                                                    cur_user + // Current user ID
                                                    ',"IsActivate":"I"}', // Deactivation status
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({ // Displaying error message
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Displaying success message
                                                            $$('StateContingencyTokenIPSwith').setValue(0); // Setting switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for Google token
                            id: 'ContingencyTokenGoogle', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission for displaying this form
                                'betShopManagementSecurityChangesContingencyTokenGoogleSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesContingencyTokenGoogleSwitch', // CSS classes for styling
                            rows: [ // Array of rows within the form
                                { view: 'label', label: _('Token Google') }, // Label for the form
                                {
                                    id: 'StateContingencyTokenGoogleSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for activation
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyTokenGoogleSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyTokenGoogle","Id":' +
                                                    cur_user + // Current user ID
                                                    ',"IsActivate":"A"}', // Activation status
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({ // Displaying error message
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Displaying success message
                                                            $$('StateContingencyTokenGoogleSwith').setValue(1); // Setting switch value to on
                                                        },
                                                    },
                                                );
                                        } else { // If switch is off
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyTokenGoogle","Id":' +
                                                    cur_user + // Current user ID
                                                    ',"IsActivate":"I"}', // Deactivation status
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({ // Displaying error message
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Displaying success message
                                                            $$('StateContingencyTokenGoogleSwith').setValue(0); // Setting switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for canceling account
                            id: 'CancelAccount', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('betShopManagementChangesCancelAccountSwitch', 'Switch'), // Check permission for displaying this form
                            css: 'secutity prm-betShopManagementChangesCancelAccountSwitch', // CSS classes for styling
                            rows: [ // Array of rows within the form
                                {
                                    css: 'centrar', // CSS class for centering the button
                                    id: 'buttonCancelAccount', // Unique identifier for the button
                                    view: 'button', // Button view
                                    labelWidth: 55, // Width of the label
                                    value: _('Cancelar Cuenta'), // Button text
                                    click: () => { // Click event handler for the button
                                        webix.confirm({ // Confirmation dialog for account cancellation
                                            type: 'confirm-warning',
                                            text:
                                                _('Advertencia!') +
                                                '<br/>' +
                                                _('Desea cancelar la cuenta del punto de venta?'), // Warning message
                                            ok: _('Cancelar Cuenta'), // Text for the confirmation button
                                            cancel: _('Salir'), // Text for the cancel button
                                            callback: function(action) { // Callback for confirmation dialog
                                                if (action === true) { // If confirmed
                                                    webix
                                                        .ajax() // Initiating an AJAX request
                                                        .headers({
                                                            'Content-type': 'application/json', // Setting content type to JSON
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                            '{"Action":"CancelAccount","Id":' +
                                                            cur_user + // Current user ID
                                                            ',"IsActivate":"A"}', // Activation status
                                                            {
                                                                error: function(text, data, XmlHttpRequest) { // Error callback
                                                                    webix.message({ // Displaying error message
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _('Ocurrio un error.'),
                                                                    });
                                                                },
                                                                success: function(text, data, XmlHttpRequest) { // Success callback
                                                                    text = JSON.parse(text); // Parsing response text
                                                                    if (text.HasError) { // Check for errors in response
                                                                        webix.message({ // Displaying error message
                                                                            title: _('¡Error!'),
                                                                            type: 'alert-error',
                                                                            text: _('Ocurrio un error.'),
                                                                        });
                                                                    } else {
                                                                        webix.message(_('Cambios Realizados')); // Displaying success message
                                                                    }
                                                                },
                                                            },
                                                        );
                                                }
                                            },
                                        });
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for retired state
                            id: 'ContingencyRetired', // Unique identifier for the form
                            hidden: !devConfig.getPermAction( // Check permission for displaying this form
                                'betShopManagementSecurityChangesContingencyRetiredSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-betShopManagementSecurityChangesContingencyRetiredSwitch', // CSS classes for styling
                            rows: [ // Array of rows within the form
                                { view: 'label', label: _('Retirado') }, // Label for the form
                                {
                                    id: 'StateContingencyRetiredSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for activation
                                    labelWidth: 55, // Width of the label
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyRetiredSwith').getValue() == 1) { // Check if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyRetired","Id":' +
                                                    cur_user + // Current user ID
                                                    ',"IsActivate":"A"}', // Activation status
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({ // Displaying error message
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Displaying success message
                                                            $$('StateContingencyRetiredSwith').setValue(1); // Setting switch value to on
                                                        },
                                                    },
                                                );
                                        } else { // If switch is off
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyRetired","Id":' +
                                                    cur_user + // Current user ID
                                                    ',"IsActivate":"I"}', // Deactivation status
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({ // Displaying error message
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Displaying success message
                                                            $$('StateContingencyRetiredSwith').setValue(0); // Setting switch value to off
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Define the upper_section object with properties for height, CSS class, and rows configuration
        const upper_section = {
            // Set height based on the document's body width
            height: document.body.offsetWidth < 500 ? 1950 : 700,
            // CSS class for styling
            css: 'secutity',
            // Array of rows containing column configurations
            rows: [
                {
                    // Margin for the row
                    margin: 10,
                    // Array of columns, with 'left' presumably defined elsewhere
                    cols: [left],
                },
            ],
        };

        // Return an object representing a form view with specific properties
        return {
            // Type of view
            view: 'form',
            // Unique identifier for the form
            id: 'myForm',
            // Array of rows to be included in the form, including upper_section
            rows: [upper_section],
            // Validation rules for form fields
            rules: {
                // Rule to ensure the 'fname' field is not empty
                fname: webix.rules.isNotEmpty,
            },
        }; // Placeholder for the configuration content of the view
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        webix.ready(function() {
            // Get the height of the elements with IDs 'a1', 'a2', and 'a3'
            var ancho1 = $$('a1').$height;
            var ancho2 = $$('a2').$height;
            var ancho3 = $$('a3').$height;

            // Get the width of the elements with IDs 'a1', 'a2', and 'a3'
            var alto1 = $$('a1').$width;
            var alto2 = $$('a2').$width;
            var alto3 = $$('a3').$width;

            // Hide element 'a1' if its height is greater than 200
            if (ancho1 > 200) {
                $$('a1').hide();
            }

            // Log the height of element 'a2'
            console.log(ancho2);

            // Hide element 'a2' if its height is greater than 200
            if (ancho2 > 200) {
                $$('a2').hide();
            }

            // Hide element 'a3' if its height is greater than 200
            if (ancho3 > 200) {
                $$('a3').hide();
            }
        });

        // Retrieve the current user parameter from the URL
        const cur_user = this.getParam('user', true);

        // Add CSS styles for background colors
        webix.html.addStyle('.bkgRed{ background:rgba(255, 0, 0, 0.5803921568627451) !important; }');
        webix.html.addStyle('.bkgGreen{ background:rgba(3, 199, 3, 0.35) !important; }');

        // Perform an AJAX GET request to retrieve client data by ID
        webix.ajax().get(devConfig.geturlApi() + 'Client/GetClientSpById', 'id=' + cur_user, {
            // Handle error response
            error: function(text, data, XmlHttpRequest) {
                webix.message({
                    title: _('¡Error!'),
                    type: 'alert-error',
                    text: _('Ocurrio un error.'),
                });
            },
            // Handle successful response
            success: function(text, data, XmlHttpRequest) {
                text = JSON.parse(text); // Parse the JSON response

                // Set the value of the 'IP' element to the retrieved IP address
                $$('IP').setValue(text[0].IP);

                // Set the state switch values based on the retrieved data
                if (text[0].IsActivate == 'A') {
                    $$('StateSwith').setValue(1);
                } else {
                    $$('StateSwith').setValue(0);
                }
                if (text[0].AllowDeposits == 'A') {
                    $$('StateContingencyRecargaSwith').setValue(1);
                } else {
                    $$('StateContingencyRecargaSwith').setValue(0);
                }
                if (text[0].IsActivateContingency == 'A') {
                    $$('StateContingencySwith').setValue(1);
                } else {
                    $$('StateContingencySwith').setValue(0);
                }
                if (text[0].IsActivateContingencyDeportivas == 'A') {
                    $$('StateContingencyDeportivasSwith').setValue(1);
                } else {
                    $$('StateContingencyDeportivasSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyCasino == 'A') {
                    $$('StateContingencyCasinoSwith').setValue(1);
                } else {
                    $$('StateContingencyCasinoSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyCasinoVivo == 'A') {
                    $$('StateContingencyCasinoVivoSwith').setValue(1);
                } else {
                    $$('StateContingencyCasinoVivoSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyVirtuales == 'A') {
                    $$('StateContingencyVirtualesSwith').setValue(1);
                } else {
                    $$('StateContingencyVirtualesSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyPoker == 'A') {
                    $$('StateContingencyPokerSwith').setValue(1);
                } else {
                    $$('StateContingencyPokerSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyWithdrawals == 'A') {
                    $$('StateContingencyWithdrawalsSwith').setValue(1);
                } else {
                    $$('StateContingencyWithdrawalsSwith').setValue(0);
                }
                if (text[0].IsRestrictionIP == 'A') {
                    $$('StateContingencyRestriccionIPSwith').setValue(1);
                } else {
                    $$('StateContingencyRestriccionIPSwith').setValue(0);
                }
                if (text[0].IsTokenIP == 'A') {
                    $$('StateContingencyTokenIPSwith').setValue(1);
                } else {
                    $$('StateContingencyTokenIPSwith').setValue(0);
                }
                if (text[0].IsTokenGoogle == 'A') {
                    $$('StateContingencyTokenGoogleSwith').setValue(1);
                } else {
                    $$('StateContingencyTokenGoogleSwith').setValue(0);
                }
                if (text[0].IsTokenLocal == 'A') {
                    // No action defined for IsTokenLocal
                } else {
                    // No action defined for else case
                }
                if (text[0].IsRetired == 'A') {
                    $$('StateContingencyRetiredSwith').setValue(1);
                } else {
                    $$('StateContingencyRetiredSwith').setValue(0);
                }
                if (text[0].IsActivateDniAnterior == 'A') {
                    $$('StateDniAnterior').setValue(1);
                } else {
                    $$('StateDniAnterior').setValue(0);
                }
                if (text[0].IsActivateDniPosterior == 'A') {
                    $$('StateDniPosterior').setValue(1);
                } else {
                    $$('StateDniPosterior').setValue(0);
                }

                // Log the retrieved data for debugging
                console.log(text);
            },
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
